import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { Icons } from 'svgs'
import Flex from 'UIKit/Box/Flex'
import CircleLoader from 'UIKit/Loader/CircleLoader'
import { PagingProps, StyledButtonPaging } from 'UIKit/Table/Paging'
import Text from 'UIKit/Text'

const NavigationPage: React.FC<PagingProps> = ({ pagination, ...props }) => {
  const { page } = pagination
  const { t } = useTranslation()

  return (
    !pagination.hide && (
      <Flex alignItems="center" {...props}>
        <StyledButtonPaging
          background="transparent"
          mr="8px"
          disabled={!pagination.canGotoFirst}
          onClick={() => pagination.gotoFirstPage()}
        >
          <Text fontSize="14px" color="textSubtle">
            <Trans>First</Trans>
          </Text>
        </StyledButtonPaging>

        <StyledButtonPaging
          variant="subtle"
          padding="4px"
          disabled={!pagination.canPrev}
          onClick={() => pagination.prevPage()}
        >
          <Icons.ChevronLeftIcon width="16px" height="16px" />
        </StyledButtonPaging>
        <Text fontSize="12px" letterSpacing={1.2} color="textTertiary" fontWeight={600} mx="12px">
          {t('Page {{page}}', {
            page,
          })}
        </Text>
        <StyledButtonPaging
          variant="subtle"
          disabled={!pagination.canNext || pagination.isCanNextChecking}
          onClick={() => pagination.nextPage()}
        >
          {pagination.isCanNextChecking ? <CircleLoader /> : <Icons.ChevronRightIcon width="16px" height="16px" />}
        </StyledButtonPaging>

        <StyledButtonPaging
          ml="8px"
          background="transparent"
          disabled={!pagination.canGotoLast}
          onClick={() => pagination.gotoLastPage()}
        >
          <Text fontSize="14px" color="textSubtle">
            <Trans>Last</Trans>
          </Text>
        </StyledButtonPaging>
      </Flex>
    )
  )
}

export default NavigationPage
